import { FaWhatsapp } from 'react-icons/fa';

function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/51935438935?text=Vengo%20de%20la%20p%C3%A1gina,%20deseo%20m%C3%A1s%20informaci%C3%B3n."
      className="whatsapp-float"
      target="_blank"
      rel="noreferrer"
    >
      <FaWhatsapp />
    </a>
  );
}

export default WhatsAppButton;
